// @ts-ignore
/* eslint-disable */
import { request } from 'umi';

/** Get captcha ID GET /api/admin/captcha/id */
export async function getCaptchaId(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.Captcha>>('/api/admin/captcha/id', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Response captcha image GET /api/admin/captcha/image */
export function getCaptchaImageURL(id: string) {
  return `/api/admin/captcha/image?captcha_id=${id}&reload=1&ts=${new Date().getTime()}`;
}

/** Login system with username and password POST /api/admin/login */
export async function login(body: API.LoginForm, options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.LoginToken>>('/api/admin/login', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** Logout system POST /api/admin/current/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.ResponseResult<any>>('/api/admin/current/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** Query current user menus based on the current user role GET /api/admin/current/menus */
export async function fetchCurrentMenus(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.Menu[]>>('/api/admin/current/menus', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Change current user password PUT /api/admin/current/password */
export async function updateCurrentPassword(
  body: API.UpdateLoginPassword,
  options?: { [key: string]: any },
) {
  return request<API.ResponseResult<any>>('/api/admin/current/password', {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

/** Refresh current access token POST /api/admin/current/refresh-token */
export async function refreshToken(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.LoginToken>>('/api/admin/current/refresh-token', {
    method: 'POST',
    ...(options || {}),
  });
}

/** Get current user info GET /api/admin/current/user */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<API.ResponseResult<API.User>>('/api/admin/current/user', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Change current user info PUT /api/admin/current/user */
export async function updateCurrentUser(body: API.User, options?: { [key: string]: any }) {
  return request<API.ResponseResult<any>>('/api/admin/current/user', {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}
